import {
  deserializeVtkImageData,
  serializeVtkImageData,
} from '@/src/core/remote/transformers/vtkImageData';

export const DefaultSerializeTransformers = [serializeVtkImageData];
export const DefaultDeserializeTransformers = [deserializeVtkImageData];

type ObjectTransformer = (obj: unknown) => unknown;

export function transformObject(input: unknown, transform: ObjectTransformer): unknown {
  const output = transform(input);

  if (!output || typeof output !== 'object') {
    return output;
  }

  if (Array.isArray(output)) {
    return output.map(o => transformObject(o, transform));
  }

  return Object.entries(output).reduce(
    (obj, [key, value]: [string, unknown]) => ({ ...obj, [key]: value }),
    {} as Record<string, unknown>,
  );
}

export function transformObjects(
  args: unknown[],
  transform: ObjectTransformer,
) {
  return args.map(arg => transformObject(arg, transform));
}
